import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CMSFactory from 'factories/CMS'
import ProductFactory from 'factories/Products'
import PubSub from 'services/PubSub/'
import StorageService from 'services/StorageService'
import TagManagerService from 'services/TagManager'
import { actionsType, translateFlag } from 'config/constants'
import { useLogged } from 'hooks'
import SalesChannel from 'services/SalesChannel'
import { getImageV2, slugify } from 'utils'

const useShelfProductHook = (props) => {
    const { callback, notPDP, product, callbackAddToCart, addToList, gtmData, customSize } = props

    let categoriesIds =
        product &&
        product.categoriesIds &&
        product.categoriesIds.length &&
        product.categoriesIds[0].split('/').filter(Boolean).slice(-1).pop()
    let idCategory = categoriesIds
    let qtyInit = props.qtyInit ? props.qtyInit * 1 : 0
    const item = product.items ? product.items[0] : false
    const sku = item.itemId
    let controlsConfig = null
    const sc = SalesChannel.getSalesChannel()

    const [load, setLoad] = useState(null)

    const isLogged = useLogged(false)

    if (item) {
        controlsConfig = {
            unitSale: product['Pesable x Unidad'] && product['Pesable x Unidad'][0] ? translateFlag[product['Pesable x Unidad'][0]] : false,
            unitMultiplier: item.unitMultiplier,
            measurementUnit: item.measurementUnit,
            maxItems: item.maxItems - (item.inCart ? item.inCart : 0),
            maxItemsOrigin: item.maxItems,
            customClass: props.small ? props.small : false,
            tagManagerData: { product: product, listTitle: props.listTitle, position: props.position },
        }
    }

    const gtmWithoutStock = () => {
        if (!stock && item) {
            let storeName = StorageService.getItem('store_name')
            if (!storeName) {
                storeName = 'Jumbo Chile'
            }
            TagManagerService.productWithoutStock(storeName + ' - ' + props.listTitle, item.itemId, item.name)
        }
    }

    const hasStock = (_item) => {
        if (!_item) return false
        const commertialOffer = _item.sellers && _item.sellers[0] ? _item.sellers[0].commertialOffer : false
        return !!(
            commertialOffer &&
            commertialOffer.ListPrice !== 0 &&
            commertialOffer.AvailableQuantity &&
            commertialOffer.AvailableQuantity > 0
        )
    }

    const openPreView = (prod) => {
        PubSub.dispatch('open_product_preview', { product: prod, title: props.listTitle, position: props.position })
    }

    const openModalAddToList = (itemID) => {
        PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { skuId: itemID, config: controlsConfig })
    }

    const producRedirect = () => {
        PubSub.dispatch('product_redirect')
    }

    const productClick = () => {
        TagManagerService.productClick(props.product, props.listTitle, props.position)

        StorageService.setItem('list_pdp', props.listTitle)
    }

    const callbackLoading = (loading) => {
        setLoad(loading)
    }

    const openDrawer = () => {
        const _categoryIds =
            product && product.categoriesIds && product.categoriesIds.length && product.categoriesIds[0].split('/').filter(Boolean)
        let categoryParent = null
        _categoryIds.forEach((_category) => {
            if (idCategory != _category) {
                categoryParent = _category
            }
        })
        PubSub.dispatch('drawer_similar_products_open', { skuId: sku, categoryId: idCategory, categoryParent: categoryParent })

        TagManagerService.interaction(sc + ' - ' + 'Productos Similares PLP', sku + ' - ' + item.name, 'Click: Ver Similares')
    }

    const goToBrand = (brand) => {
        const formatBrand = slugify(brand);
        props.history.push(`/${formatBrand}`);
        TagManagerService.interaction("Click Marca", brand, product?.categories[0]);
    }

    const sizeImage = customSize?.desktop ? customSize.desktop : 180;
    const skuData = item && product.SkuData && product.SkuData[item.itemId] ? product.SkuData[item.itemId] : {}
    const productImage = item ? getImageV2(item, sizeImage) : product.ImageUrl
    const link = notPDP ? '#' : product.linkText ? `/${product.linkText}/p` : ''
    const stock = item ? hasStock(item) : false

    const dateServer = item && item.date_server ? item.date_server : new Date().getTime()
    const dateEnd = CMSFactory.milliseconds(item.end_date)
    const dateInit = CMSFactory.milliseconds(item.start_date)
    const productName = product.productName || product.ProductName
    if (item) {
        item.skuData = item.skuData || {}
    }

    const extraActions = (
        <div className="shelf-product-extra-actions">
            {item && (
                <button className="font-icn view-more tooltip-container mobile-click" onClick={() => openPreView(product)}>
                    <span className="tooltip">Vista Rápida</span>
                </button>
            )}
            <button className="tooltip-container mobile-click" onClick={() => openModalAddToList(item.itemId || product.Id)}>
                <i className="add-list-icon jumbo-icon-new-list"></i>
                <span className="tooltip">Agregar a una lista</span>
            </button>
        </div>
    )
    const unitMeasurement = item ? ProductFactory.formatWeight(item.measurementUnit, item.unitMultiplier) : ''
    const exclusiveJumbo =
        product && product['Exclusivo Jumbo'] && product['Exclusivo Jumbo'][0] === 'Sí' ? product['Exclusivo Jumbo'][0] : null

    return {
        unitMeasurement,
        exclusiveJumbo,
        extraActions,
        dateServer,
        dateEnd,
        dateInit,
        productName,
        skuData,
        productImage,
        link,
        openDrawer,
        callbackLoading,
        productClick,
        producRedirect,
        gtmWithoutStock,
        openModalAddToList,
        load,
        callback,
        callbackAddToCart,
        qtyInit,
        isLogged,
        stock,
        item,
        controlsConfig,
        addToList,
        product,
        gtmData,
        goToBrand
    }
}

useShelfProductHook.propTypes = {
    product: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number,
    item: PropTypes.object,
    limitTitle: PropTypes.number,
    callback: PropTypes.func,
    qtyInit: PropTypes.string,
    notPDP: PropTypes.bool,
    gtmData: PropTypes.object,
    favorites: PropTypes.array,
    callbackAddToCart: PropTypes.func,
}

export default useShelfProductHook
